import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';

import { 
	setModoTela, 
	getLista, getListaProduto, getListaUnidade
} from './fechamentoEstoqueDiarioActions';

class FechamentoEstoqueDiario extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		dataInicial: DateFormat.formatarDataSqlParaTela(DateFormat.getTimestampParaData(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))),
		dataFinal: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaProduto();
		this.props.getListaUnidade();

		let idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaProduto();
			this.props.getListaUnidade();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
	}

    render() {
        return (
            <div>
                <Content>					
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		const lista = this.props.lista.filter(item => {
			if (this.state.id_unidade && item.id_unidade != this.state.id_unidade) {
				return false;
			}
			if (this.state.id_produto && item.id_produto != this.state.id_produto) {
				return false;
			}
			return true;
		}).filter(item => {
			if (this.state.dataInicial
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_estoque)) < DateFormat.formatarDataTelaParaSql(this.state.dataInicial)) {
				return false;
			}
			if (this.state.dataFinal
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_estoque)) > DateFormat.formatarDataTelaParaSql(this.state.dataFinal)) {
				return false;
			}
			return true;
		});
	
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getLista();
								}} />
						</Grid>
						{/*<Grid cols='6 6 3 2'>
							<ExcelFile
								filename={'Estoque Diário'}
								element={
									<Button
									text='Exportar'
									type={'primary'}
									icon={'fa fa-plus'} />
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									datahora_fechamentoEstoqueDiario: DateFormat.formatarDataHoraSqlParaTela(item.datahora_fechamentoEstoqueDiario),
									saldo_inicial: FormatUtils.formatarValorTelaDecimal(item.saldo_inicial, 2),
									quantidade: FormatUtils.formatarValorTelaDecimal(item.quantidade, 2),
									saldo_final: FormatUtils.formatarValorTelaDecimal(item.saldo_final, 2),
									datahora_petroshow: DateFormat.formatarDataHoraSqlParaTela(item.datahora_petroshow),
									quantidade_petroshow: FormatUtils.formatarValorTelaDecimal(item.quantidade_petroshow, 2),
									diferenca_petroshow:  item.datahora_petroshow 
										? FormatUtils.formatarValorTelaDecimal(parseFloat(item.saldo_final || 0) - parseFloat(item.quantidade_petroshow || 0), 2)
										: null
								}))} name='FechamentoEstoqueDiario'>
									<ExcelColumn label='Data Hora' value='datahora_fechamentoEstoqueDiario' />
									<ExcelColumn label='Placa' value='placa_veiculo' />
									<ExcelColumn label='Tipo' value='nome_tipo' />
									<ExcelColumn label='Controle' value='numero_controle' />
									<ExcelColumn label='Saldo Inicial' value='saldo_inicial' />
									<ExcelColumn label='Operação' value='operacao' />
									<ExcelColumn label='Quantidade' value='quantidade' />
									<ExcelColumn label='Saldo Final' value='saldo_final' />
									<ExcelColumn label='Atualização Petroshow' value='datahora_petroshow' />
									<ExcelColumn label='Petroshow' value='quantidade_petroshow' />
									<ExcelColumn label='Diferença' value='diferenca_petroshow' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>*/}
					</Row>

				</ContentCardHeader>
				<ContentCardBody>

					<Row>
						<Select
							label='Unidade' placeholder='Selecione a unidade'
							cols='6 6 4 2'
							options={this.props.listaUnidade}
							value={this.state.id_unidade}
							onChange={value => {
								this.setState({ 
									...this.state, 
									id_unidade: value 
								});
							}} />

						<Select
							label='Produto' placeholder='Selecione o produto'
							cols='6 6 4 2'
							options={this.props.listaProduto}
							value={this.state.id_produto}
							onChange={value => {
								this.setState({ 
									...this.state, 
									id_produto: value 
								});
							}} />

						<LabelAndInputMask
							name='data_inicial'
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							value={this.state.dataInicial}
							onChange={data => {
								this.setState({
									...this.state,
									dataInicial: data.target.value
								});
							}} />

						<LabelAndInputMask
							name='data_final'
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							value={this.state.dataFinal}
							onChange={data => {
								this.setState({
									...this.state,
									dataFinal: data.target.value
								});
							}} />
					</Row>
					<Table responsive>
						<THead>
							<Tr>
								<Th rowspan={2} alignCenter>Unidade</Th>
								<Th rowspan={2} alignCenter>Produto</Th>

								<Th
									colspan={4}
									alignCenter
									borderLeft='2px solid #94a3b8'
									borderRight='2px solid #94a3b8'
								>
									Estoque Inicial
								</Th>

								<Th
									colspan={4}
									alignCenter
									borderRight='2px solid #94a3b8'
								>
									Estoque Final
								</Th>
							</Tr>

							<Tr>
								{/* INICIAL */}
								<Th
									borderLeft='2px solid #94a3b8'
									alignCenter
								>
									Data/Hora
								</Th>

								<Th
									alignRight>
									Infinitum
								</Th>

								<Th
									alignRight>
									Petroshow
								</Th>

								<Th
									borderRight='2px solid #94a3b8'
									alignRight
								>
									Diferença
								</Th>

								{/* FINAL */}
								<Th
									alignCenter>
									Data/Hora
								</Th>

								<Th
									alignRight>
									Infinitum
								</Th>

								<Th
									alignRight>
									Petroshow
								</Th>

								<Th
									borderRight='2px solid #94a3b8'
									alignRight
								>
									Diferença
								</Th>
							</Tr>
						</THead>

						<TBody>
							{lista.map(item => {

								const diferencaInicial =
									parseFloat(item.estoque_infinitum_inicial || 0) -
									parseFloat(item.quantidade_petroshow_inicial || 0);

								const diferencaFinal =
									parseFloat(item.estoque_infinitum_final || 0) -
									parseFloat(item.quantidade_petroshow_final || 0);

								return (
									<Tr
										key={item.id}
										className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ linhaSelecionada: item.id })}
									>

										<Td width={150} alignCenter small>
											{item.nome_unidade}
										</Td>

										<Td width={150} alignCenter small>
											{item.nome_produto}
										</Td>

										{/* INICIAL */}
										<Td
											width={150}
											alignCenter
											small
											borderLeft='2px solid #94a3b8'
										>
											{DateFormat.formatarDataHoraSqlParaTela(
												item.datahora_estoque_inicial
											)}
										</Td>

										<Td
											width={150}
											alignRight
											small
										>
											{FormatUtils.formatarValorTelaDecimal(
												item.estoque_infinitum_inicial,
												0
											)}
										</Td>

										<Td
											width={150}
											alignRight
											small
										>
											{FormatUtils.formatarValorTelaDecimal(
												item.quantidade_petroshow_inicial,
												0
											)}
										</Td>

										<Td
											width={150}
											alignRight
											small
											borderRight='2px solid #94a3b8'
										>
											{FormatUtils.formatarValorTelaDecimal(
												diferencaInicial,
												0
											)}
										</Td>

										{/* FINAL */}
										<Td
											width={150}
											alignCenter
											small
										>
											{DateFormat.formatarDataHoraSqlParaTela(
												item.datahora_estoque_final
											)}
										</Td>

										<Td
											width={150}
											alignRight
											small
										>
											{FormatUtils.formatarValorTelaDecimal(
												item.estoque_infinitum_final,
												0
											)}
										</Td>

										<Td
											width={150}
											alignRight
											small
										>
											{FormatUtils.formatarValorTelaDecimal(
												item.quantidade_petroshow_final,
												0
											)}
										</Td>

										<Td
											width={150}
											alignRight
											small
											borderRight='2px solid #94a3b8'
										>
											{FormatUtils.formatarValorTelaDecimal(
												diferencaFinal,
												0
											)}
										</Td>

									</Tr>
								)
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.fechamentoEstoqueDiario.modoTela,
	lista: state.fechamentoEstoqueDiario.lista,
    listaUnidade: state.fechamentoEstoqueDiario.listaUnidade,
    listaProduto: state.fechamentoEstoqueDiario.listaProduto
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela,
	getLista, getListaProduto, getListaUnidade
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(FechamentoEstoqueDiario);
